import React, { type ReactNode } from 'react';
import { SmartCardProvider, type CardClient } from '@atlaskit/link-provider';
import type { ProductType } from '@atlaskit/linking-common';
import { fg } from '@atlassian/jira-feature-gating';

/**
 * @deprecated Do not use. The SmartCardProvider is already mounted at the root level of the Jira single page app.
 * Delete this component when cleaning up fun-1689_single_root_smart_card_provider.
 */
export const SmartCardProviderMigration = ({
	children,
	product,
	client,
}: {
	children: ReactNode;
	product?: ProductType;
	client?: CardClient;
}) =>
	fg('fun-1689_single_root_smart_card_provider') ? (
		children
	) : (
		<SmartCardProvider product={product} client={client}>
			{children}
		</SmartCardProvider>
	);
